module.exports = __webpack_public_path__ + "static/blackcherry-3c52d990e9b7225f6c068a44a3573d52.jpg";